import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface DiscountCode {
  tipo: string; // 'PORCENTAJE' o 'FIJO'
  monto: number;
  estado: boolean;
  codigo: string;
  descripcion?: string;
  fechaInicio?: string;
  fechaFin?: string;
  limiteUso?: number;
  usosActuales?: number;
}

export interface DiscountResponse {
  success: boolean;
  message: string;
  discount?: DiscountCode;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DiscountService {
  private apiUrl = `${environment.apiUrl}/discounts`;

  constructor(private http: HttpClient) { }

  /**
   * Valida un código de descuento
   */
  validateDiscountCode(codigo: string): Observable<DiscountResponse> {
    return this.http.post<DiscountResponse>(`${this.apiUrl}/validate`, { codigo });
  }

  /**
   * Aplica un descuento a un monto
   */
  applyDiscount(monto: number, discountCode: DiscountCode): number {
    if (discountCode.tipo === 'FIJO') {
      // Descuento por monto fijo
      return Math.max(0, monto - discountCode.monto);
    } else if (discountCode.tipo === 'PORCENTAJE') {
      // Descuento por porcentaje
      return monto * (1 - discountCode.monto / 100);
    }
    return monto;
  }

  /**
   * Calcula el monto del descuento
   */
  calculateDiscountAmount(monto: number, discountCode: DiscountCode): number {
    if (discountCode.tipo === 'FIJO') {
      // Descuento por monto fijo
      return Math.min(discountCode.monto, monto);
    } else if (discountCode.tipo === 'PORCENTAJE') {
      // Descuento por porcentaje
      return monto * (discountCode.monto / 100);
    }
    return 0;
  }

  /**
   * Obtiene un descuento del usuario por código
   */
  getUserDiscountByCode(codigo: string): Observable<DiscountResponse> {
    return this.http.get<DiscountResponse>(`${this.apiUrl}/user/${codigo}`);
  }

  /**
   * Incrementa el uso de un descuento del usuario
   */
  incrementDiscountUsage(codigo: string): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(`${this.apiUrl}/increment-usage/${codigo}`, {});
  }
}
